import { createContext } from "react";

const UserScreen = createContext<any>(null);

export default UserScreen;
